import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface CaptchaDataRes {
  captcha_id?: string
  /** base64图片 */
  captcha_image?: string
}

@Injectable()
export class CaptchaService {
  constructor (private http: Http) {}

  /** 获取验证码 */
  getCaptchaData () {
    return this.http.post<CaptchaDataRes>('/captcha/get_captcha', {})
  }
}
